// @ts-ignore
import { saveSvgAsPng as savePng, svgAsPngUri } from 'save-svg-as-png';
// @ts-ignore
import saveAs from 'file-saver';

export const saveSvgAsSvg = (svg: SVGElement, name: string) => {
  const element = svg.cloneNode(true) as SVGElement;

  element.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  // Some design apps like "invision" mess up the width and height of the svg so we remove
  // those attributes to make sure the svg is rendered correctly
  element.removeAttribute('width');
  element.removeAttribute('height');

  const data = element.outerHTML.replace(
    '<path fill="#FFFFFF" d="M0,0 h37v37H0z"></path>',
    ''
  );
  const svgBlob = new Blob([data], {
    type: 'image/svg+xml;charset=utf-8',
  });
  const svgUrl = URL.createObjectURL(svgBlob);
  const downloadLink = document.createElement('a');

  downloadLink.href = svgUrl;
  downloadLink.download = `${name}.svg`;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const saveSvgAsPng = (svg: SVGElement, name: string) => {
  savePng(svg, `${name}.png`, { scale: 6 });
};

export const svgToSvgBlob = (svg: SVGElement): string => {
  return new XMLSerializer().serializeToString(svg);
};

export const svgToPngBlob = async (svg: SVGElement): Promise<string> => {
  // Ensure SVG has viewBox (use your original SVG sizes here)
  if (!svg.hasAttribute('viewBox')) {
    const width = svg.getAttribute('width') || '29';
    const height = svg.getAttribute('height') || '29';
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
  }

  // Calculate scale to get ~600x600 output from original size
  const viewBox = svg.getAttribute('viewBox')!;
  const [, , vbWidth, vbHeight] = viewBox.split(' ').map(Number);
  const scale = 600 / Math.max(vbWidth, vbHeight);

  const uri = await svgAsPngUri(svg, {
    scale,
  });

  const idx = uri.indexOf('base64,') + 'base64,'.length;
  return uri.substring(idx);
};

export const saveFile = async (blob: Blob, name: string) => {
  return saveAs(blob, name);
};
